import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ProjectManagementService} from "../../services/project-management.service";
import {DataService} from "../../services/data.service";
import {FrontEndService} from "../../services/front-end.service";
import {UserManagementService} from "../../services/user-management.service";
import {StateService} from '@uirouter/angular';
import {Transition} from '@uirouter/angular';
import {LogService} from "../../services/log.service";
import {Observable} from "rxjs";

@Component({
    selector: 'app-project-wall-tab',
    templateUrl: './project-wall-tab.component.html',
    styleUrls: ['./project-wall-tab.component.scss']
})
export class ProjectWallTabComponent implements OnInit, OnDestroy {

    noMoreActivity = false;

    // Timer every 30 secs.
    timer = Observable.timer(0, 30000);
    timer_subscription: any;

    wall_post_list = this.dataService.wall_list;

    card_loading = false;
    fetch_more = true;
    wall_offset = 0;
    wallLoaded = false;

    @Input() download_file = function () {};

    constructor(
        private project_management_service: ProjectManagementService,
        public dataService: DataService,
        public front_end_service: FrontEndService,
        private userManagementService: UserManagementService,
        private stateService: StateService,
        private transition: Transition,
        private logService: LogService
    ) { }

    ngOnInit() {
        this.wall_offset = 0;
        this.wall_post_list = this.dataService.wall_list;

        this.timer_subscription = this.timer.subscribe(() => {
            if (this.dataService.selected_project !== 0) {
                this.wall_get(this.dataService.selected_project, this.dataService.wall_limit, 0);
            }
        });
    }

    ngOnDestroy() {
        this.timer_subscription.unsubscribe();
    }

    /**
     * Get wall data
     * @param project_id
     * @param limit
     * @param offset
     * @param continue_fetch
     */
    wall_get(
        project_id,
        limit,
        offset,
        continue_fetch = false,
    ) {
        if (this.dataService.wall_get_waiting_for_response && continue_fetch === false) {
            // Stop further http requests until last req. gives ans/
            this.logService.printLog("wall get waiting for response.");
        } else {
            this.dataService.wall_get_waiting_for_response = true;

            this.project_management_service.wall_get(project_id, limit, offset, (resp) => {
                    this.dataService.wall_get_waiting_for_response = false;

                    if (resp.status) {
                        // Add new wall posts
                        for (let i = 0; i < resp.data.length; i++) {
                            if(this.dataService.selected_project === resp.data[i].project) {

                                const test_proj = this.dataService.get_array_details(this.dataService.wall_list, "id", resp.data[i].id);
                                // this.dataService.wall_list.splice(this.dataService.wall_list.indexOf(test_proj), 1);
                                if (test_proj === undefined) {
                                    this.dataService.wall_list.push(resp.data[i]);

                                    // sort array
                                    this.dataService.wall_list = this.dataService.sort_this(
                                        this.dataService.wall_list,
                                        "id"
                                    );

                                    // give value to this view's variable.
                                    this.wall_post_list = this.dataService.wall_list;
                                } else {
                                    // This project already exists. Just update the metadata.
                                    test_proj['wall_reply_count'] = resp.data[i]['wall_reply_count'];
                                }

                                if(continue_fetch) {
                                    this.card_loading = false;
                                }
                            }
                        }

                        // Remove any wall post which have been deleted
                        if (this.dataService.wall_count !== resp.count) {
                            this.dataService.wall_list.forEach((wall, index) => {
                                const deletedWallPost = this.dataService.get_array_details(resp.data, "id", wall.id);
                                // this.dataService.wall_list.splice(this.dataService.wall_list.indexOf(test_proj), 1);
                                if (deletedWallPost === undefined) {
                                    this.dataService.wall_list.splice(index, 1);
                                }
                            });
                        }

                        // Update count
                        this.dataService.wall_count = resp.count;
                        this.wallLoaded = true;
                    } else {
                        this.logService.printLog("Failed Project Wall controller callback");
                    }
                }
            );
        }
    }

    /**
     * Fetch more posts on scroll
     */
    onScroll() {
        this.logService.printLog("fetch_more" + JSON.stringify(this.fetch_more));
        if (this.dataService.wall_count > (this.wall_offset + 10) ) {
            this.card_loading = true;
            this.fetch_more = true;
        } else {
            this.fetch_more = false;
            this.card_loading = false;
            this.noMoreActivity = true;
        }

        if(this.fetch_more) {
            this.wall_offset += 10;

            if (this.dataService.selected_project !== 0) {
                this.wall_get(this.dataService.selected_project, this.dataService.wall_files_limit , this.wall_offset, true);
            }
        }
    }
}
